import { forwardRef } from "react";
import Col from '../Col2.js';
import CheckBoxBase from "./FieldTypeBase/CheckBox_Base.js";

const CheckBoxBlock = forwardRef((props, ref) => {
  return (
    <Col 
      key={props.objectkey}
      id={props.objectkey}
      style={props.style}
      className={`col-md-${props.field.width} field checkbox checkbox-block ${props.field.class || ""}`}
    >      
      <CheckBoxBase {...props} ref={ref} />
    </Col>
  );
});

export default CheckBoxBlock;